import axiosInstance from './../axiosInstance';


/**
 * Login user.
 *
 * @param {object} credentials
 */
export const login = credentials => {
	const url = 'users/login';
	const postData = {
		...credentials,
		returnSecureToken: true
	};
	const config = {
		timeout: 3000
	};
	return axiosInstance.post(url, postData, config);
};


/**
 * Logout user.
 *
 * @param {object} credentials
 */
export const logout = () => {
	localStorage.removeItem('token');
	localStorage.removeItem('connection');
};


/**
 * Send user's password reset link.
 *
 * @param {object} values
 */
export const resetPassword = values => {
	const url = 'users/forgottenPassword';
	const postData = {
		email: values.email,
		requestedFrom: 'partnersPortal'
	};
	return axiosInstance.post(url, postData);
}


/**
 * Token refresh.
 *
 * @param {string} token
 */
export const tokenRefresh = token => {
	return axiosInstance.post('users/refresh', token);
};
